import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../services/firebase';
import { onAuthStateChanged } from 'firebase/auth'; 

export const useUnreadMessages = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [currentUser, setCurrentUser] = useState(auth.currentUser);

  useEffect(() => {
    const unsubAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
    return () => unsubAuth();
  }, []);

  useEffect(() => {
    // 🟢 FIX 1: Explicitly clear the unread count if it's a guest user
    if (!currentUser) {
      setUnreadCount(0);
      return;
    }

    const q = query(
      collection(db, "chats"), 
      where("participants", "array-contains", currentUser.uid)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let total = 0;
      
      snapshot.docs.forEach(doc => {
        const data = doc.data();
        // Check if unreadCount exists as a map/object
        const count = data.unreadCount?.[currentUser.uid] || 0;
        total += count;
      });
      
      setUnreadCount(total);
    }, (error) => {
      // 🟢 FIX 2: Catch permission errors silently so they don't crash React
      console.error("Unread Messages Fetch Error (Guest Mode):", error.message);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return unreadCount;
};